import { useState } from 'react'
import { SidebarSort } from 'components/sidebar/components/folders/tree'
import { loadSort, saveSort } from 'components/sidebar/components/folders/viewState'

export interface SidebarSortState {
  sort: SidebarSort
  /** Sorts the sidebar for this viewer, and remembers it for this hub. */
  setSort: (sort: SidebarSort) => void
}

/**
 * The viewer's own sort for the hub's sidebar, remembered per hub in localStorage, and read again on
 * switching hub. Unlike the open folders it needs nothing from the hub to be read.
 */
export const useSidebarSort = (hubId: string): SidebarSortState => {
  const [state, setState] = useState(() => ({ hubId, sort: loadSort(hubId) }))
  // Another hub: its own sort, read before this render is shown.
  if (state.hubId !== hubId) setState({ hubId, sort: loadSort(hubId) })
  const setSort = (sort: SidebarSort): void => {
    setState({ hubId, sort })
    saveSort(hubId, sort)
  }
  return { sort: state.sort, setSort }
}
